<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FdHs9f/tc-custom/9780446549004.jpg?1732165489372" alt="This image is the cover for the book Mother Road, Route 66 Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mother Road, Route 66 Series
      </h1>
      <p class="bookDescription body article font2">
        <p>On a hot summer day in 1932, Andy Connors, who owns a garage that serves Route 66, finds himself in major trouble: He's been bitten by a rabid skunk.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dorothy Garlock
      </h2>
      
      <p class="authorDescription body article"><B>Dorothy Garlock</B> is the author of more than 50 novels that have sold 15 million+ combined copies and are published in 15 languages. She lives in Iowa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Warner Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?258a9346